import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEmailImportAccess } from '../../hooks/useEmailMenuVisibility';
import CustomLoading from '../../components/uiParts/form/CustomLoading';

interface Props {
  children: React.ReactElement;
}

/**
 * メール取り込み関連ページのルートガード。
 * 有料オプションのため、機能が有効（＋企業管理者は開始日到達）でない場合はアクセスさせない。
 * メニュー非表示に加え、直URLアクセスもここでブロックする。
 */
const ProtectedEmailImport: React.FC<Props> = ({ children }) => {
  const { loading, allowed } = useEmailImportAccess();

  if (loading) {
    return <CustomLoading loading />;
  }
  if (!allowed) {
    return <Navigate to="/home" replace />;
  }
  return children;
};

export default ProtectedEmailImport;
